class AppNotification {
    showSuccess( subject = '', message ){
        // console.log('showSuccess',subject,message);
    }
    showError( subject = '', message ){
        // console.log('showError',subject,message);
    }
}
export default new AppNotification;